import {BulkAssemblyModel} from 'molbio/bulk-assembly/backbone/BulkAssemblyFileState';
import {PREFERENCE_KEY_IGNORE, TabState, TabStateDefaults} from 'Navigation';

export default class BulkAssemblyConstructsTabState extends TabState {
  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Constructs',
      closeable: false,
      preferenceKey: PREFERENCE_KEY_IGNORE,
    };
  }

  bulkAssemblyModel(): BulkAssemblyModel {
    return this.get('bulkAssembly');
  }
}
